module.exports = __webpack_public_path__ + "img/oog_ohow.05bf2aa7.png";